import React from 'react';
import styled from 'styled-components';

import { useWalletWithPositionsQuery } from '#/api/queries/walletPositionsQueries';
import { formatUsdWithSign } from '#/lib/display/formatting';
import { useSelector } from '#/reduxState/store';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  height: var(--header-height);
  padding-right: 12px;
  padding-top: 4px;

  text-align: right;
  font-family: var(--digitsFontFamily);
  font-size: var(--small);
`;

const Label = styled.div`
  color: var(--gray4c);
`;

const Value = styled.div`
  color: var(--white);
`;

function AccountValueMenuItem() {
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const { data: walletWithPositions } = useWalletWithPositionsQuery();

  if (!walletAddress) {
    return null;
  }

  return (
    <Wrap>
      <Label>ACCOUNT VALUE</Label>
      <Value>
        {!walletWithPositions?.equity ? (
          <>
            {/* Loading */}
            &nbsp;
          </>
        ) : (
          formatUsdWithSign(walletWithPositions.equity)
        )}
      </Value>
    </Wrap>
  );
}

export default AccountValueMenuItem;
